<div class="page">
	<header class="page-header">
		<span></span>
	</header>

	<nav class="page-nav navbar navbar-dark bg-primary"></nav>

	<aside class="page-menu-left"></aside>
	<aside class="page-menu-right"></aside>

	<div class="page-content text-center completion-content">
		@if (hasCompletedFaceScan()) {
		<div class="completion-container">
			@if (pleaseWait) {
			<div>
				<div class="completion-icon">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="64"
						height="64"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<circle cx="12" cy="12" r="10"></circle>
						<polyline points="12 6 12 12 16 14"></polyline>
					</svg>
				</div>

				<h2 class="completion-title">
					{{ "survey.completion.profile-preparing-title" | translate }}
				</h2>

				<div class="completion-message">
					<p
						class="completion-text"
						[innerHTML]="'survey.completion.profile-preparing' | translate"
					></p>
				</div>
			</div>
			} @else {
			<div>
				<div class="completion-icon">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="64"
						height="64"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
						<polyline points="22 4 12 14.01 9 11.01"></polyline>
					</svg>
				</div>

				<h2 class="completion-title">
					{{ "survey.group-transition.all-completed" | translate }}
				</h2>

				<div class="completion-message">
					<p class="completion-text">
						{{ "survey.group-transition.face-scan-completed" | translate }}
					</p>
				</div>

				<div class="completion-actions d-flex justify-content-center mt-4">
					<button class="btn btn-primary btn-circle" (click)="finish()">
						{{ "survey.completion.finish-button" | translate }}
					</button>
				</div>
			</div>
			}
		</div>
		} @else {
		<div class="completion-container">
			@if (this.survey()?.IncludesAPV && this.selectedOnlyApv()) {
			<div>
				<div class="completion-icon">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="64"
						height="64"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
						<polyline points="22 4 12 14.01 9 11.01"></polyline>
					</svg>
				</div>

				<h2 class="completion-title">
					{{ "survey.completion.title" | translate }}
				</h2>

				<div class="completion-message">
					@if (pleaseWait) {
					<p class="completion-text">
						{{ "survey.completion.workplace-assessment-thank-you" | translate }}
					</p>
					} @else {
					<p class="completion-text">
						{{ "survey.completion.workplace-assessment-completed" | translate }}
					</p>
					<p class="completion-text">
						<em>{{ "survey.completion.can-change-answers" | translate }}</em>
					</p>
					}
				</div>
				@if (!pleaseWait) {
				<div class="completion-actions d-flex justify-content-center mt-4">
					<button class="btn btn-primary btn-circle" (click)="finish()">
						{{ "survey.completion.finish-button" | translate }}
					</button>
				</div>
				}
			</div>
			} @if (this.survey()?.IncludesENPS) {
			<div>
				<div class="completion-icon">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="64"
						height="64"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
						<polyline points="22 4 12 14.01 9 11.01"></polyline>
					</svg>
				</div>

				<h2 class="completion-title">
					{{ "survey.completion.title" | translate }}
				</h2>

				<div class="completion-message">
					@if (pleaseWait) {
					<p class="completion-text">
						{{ "survey.completion.workplace-assessment-thank-you" | translate }}
					</p>
					} @else {
					<p class="completion-text">
						{{ "survey.completion.enps-completed" | translate }}
					</p>
					<p class="completion-text">
						<em>{{ "survey.completion.can-change-answers" | translate }}</em>
					</p>
					}
				</div>
				@if (!pleaseWait) {
				<div class="completion-actions d-flex justify-content-center mt-4">
					<button class="btn btn-primary btn-circle" (click)="finish()">
						{{ "survey.completion.finish-button" | translate }}
					</button>
				</div>
				}
			</div>
			} @if (this.pleaseWait && isHealthChecker() && !(
			this.survey()?.IncludesAPV && this.selectedOnlyApv() ) &&
			!this.survey()?.IncludesFollowUp && !this.survey()?.IncludesENPS &&
			!hasCompletedFaceScan()) {
			<div>
				<div class="completion-icon">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="64"
						height="64"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<circle cx="12" cy="12" r="10"></circle>
						<polyline points="12 6 12 12 16 14"></polyline>
					</svg>
				</div>

				<h2 class="completion-title">
					{{ "survey.completion.profile-preparing-title" | translate }}
				</h2>

				<div class="completion-message">
					<p
						class="completion-text"
						[innerHTML]="'survey.completion.profile-preparing' | translate"
					></p>
				</div>
			</div>
			} @if (!( this.pleaseWait || (this.survey()?.IncludesAPV &&
			this.selectedOnlyApv()) || this.survey()?.IncludesFollowUp ||
			this.survey()?.IncludesENPS || hasCompletedFaceScan() ) ) {
			<div>
				<div class="completion-icon">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="64"
						height="64"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
						<polyline points="22 4 12 14.01 9 11.01"></polyline>
					</svg>
				</div>

				<h2 class="completion-title">
					{{ "survey.completion.responses-saved" | translate }}
				</h2>

				<div class="completion-message">
					@if (isHealthChecker()) {
					<p class="completion-text">
						{{ "survey.completion.finalize-message" | translate }}
					</p>
					<p class="completion-text">
						<em>{{ "survey.completion.can-change-answers" | translate }}</em>
					</p>
					} @else {
					<p
						class="completion-text"
						[innerHTML]="
              (this.survey()?.IncludesAPV
								? 'survey.completion.health-screening-apv-completed'
								: this.survey()?.IncludesHealthCheck
								? 'survey.completion.health-screening-completed'
								: 'survey.completion.finalize-message'
              ) | translate
            "
					></p>
					<p class="completion-text">
						<em>{{ "survey.completion.can-change-answers" | translate }}</em>
					</p>
					}
				</div>

				<div class="completion-actions d-flex justify-content-center mt-4">
					<button
						class="btn btn-primary btn-circle"
						(click)="finish()"
						[hidden]="pleaseWait"
					>
						{{ "survey.completion.finish-button" | translate }}
					</button>
				</div>
			</div>
			} @if (this.survey()?.IncludesFollowUp) {
			<div>
				<div class="completion-icon">
					@if (pleaseWait) {
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="64"
						height="64"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<circle cx="12" cy="12" r="10"></circle>
						<polyline points="12 6 12 12 16 14"></polyline>
					</svg>
					} @else {
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="64"
						height="64"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
						<polyline points="22 4 12 14.01 9 11.01"></polyline>
					</svg>
					}
				</div>
				@if (pleaseWait) {
				<h2 class="completion-title">
					{{ "survey.completion.profile-preparing-title" | translate }}
				</h2>

				<div class="completion-message">
					<p class="completion-text">
						{{ "survey.completion.profile-preparing-info" | translate }}
					</p>
				</div>
				} @else {
				<h2 class="completion-title">
					{{ "survey.completion.answers-registered" | translate }}
				</h2>

				<div class="completion-message">
					<p class="completion-text">
						{{ "survey.completion.finalize-message" | translate }}
					</p>
					<p class="completion-text">
						<em>{{ "survey.completion.can-change-answers" | translate }}</em>
					</p>
				</div>

				<div class="completion-actions d-flex justify-content-center mt-4">
					<button class="btn btn-primary btn-circle" (click)="finish()">
						{{ "survey.completion.finish-button" | translate }}
					</button>
				</div>
				}
			</div>
			} @if (showPreviousButton() && !pleaseWait && !hasCompletedFaceScan()) {
			<div class="completion-actions d-flex justify-content-center mt-4">
				@if ((this.survey()?.IncludesAPV && this.selectedOnlyApv() &&
				!this.finishedAPV) || this.survey()?.IncludesENPS) {
				<div class="mx-3">
					<app-back-button
						(clicked)="back()"
						[disabled]="pleaseWait && currentId == start"
					/>
				</div>
				}
				<div
					class="mx-3"
					[hidden]="
            pleaseWait ||
            (this.survey()?.IncludesAPV &&
              this.selectedOnlyApv()) ||
            this.survey()?.IncludesENPS
          "
				>
					<app-back-button
						(clicked)="back()"
						[disabled]="pleaseWait && currentId == start"
					/>
				</div>
			</div>
			}
		</div>
		}

		<footer class="page-footer d-md-none">
			<span class="logo negated"></span>
		</footer>
	</div>
</div>
